/**
 * @Description: 用户自定义标签模板类别信息相关接口
 */
import { ContentType, Method } from 'axios-mapper'
import https from '@/utils/https'
import { RootObject } from '@/model/rootObject'
import { PageRespModel } from '@/model/pageRespModel'
import { Route } from '@/constant/route'
import {
  TemplateCategoryUserModel,
  TemplateCategoryUserSearchModel,
  TemplateCategoryUserPageSearchModel,
  TemplateCategoryUserAddModel,
  TemplateCategoryUserUpdateModel,
  IdsModel
} from '@/model/product/TemplateCategoryUserModel'

const baseUrl = Route.product + '/templateCategoryUser'

/**
 * 搜索分页数据
 */
export const pageSearchTemplateCategoryUser = (param: TemplateCategoryUserPageSearchModel) => {
  return https().request<RootObject<PageRespModel<TemplateCategoryUserModel>>>(baseUrl.concat('/list'), Method.POST, param, ContentType.json)
}

/**
 * 搜索所有数据
 */
export const searchTemplateCategoryUser = (param: TemplateCategoryUserSearchModel) => {
  return https().request<RootObject<TemplateCategoryUserModel[]>>(baseUrl.concat('/list/all'), Method.POST, param, ContentType.json)
}

/**
 * 根据ID查找数据
 */
export const getTemplateCategoryUser = (id: number) => {
  return https().request<RootObject<TemplateCategoryUserModel>>(baseUrl.concat('/get/').concat(id.toString()), Method.GET, undefined, ContentType.json)
}

/**
 * 添加数据
 */
export const addTemplateCategoryUser = (param: TemplateCategoryUserAddModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/add'), Method.POST, param, ContentType.json)
}

/**
 * 更新数据
 */
export const updateTemplateCategoryUser = (param: TemplateCategoryUserUpdateModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/update'), Method.POST, param, ContentType.json)
}

/**
 * 删除数据
 */
export const removeTemplateCategoryUser = (id: number) => {
  return https().request<RootObject<any>>(baseUrl.concat('/remove/').concat(id.toString()), Method.POST, undefined, ContentType.json)
}

/**
 * 批量删除数据
 */
export const batchRemoveTemplateCategoryUser = (param: IdsModel) => {
  return https().request<RootObject<any>>(baseUrl.concat('/batch/remove'), Method.POST, param, ContentType.json)
}
